import React from 'react';
import PropTypes from 'prop-types';

function Date (props) {
  const item = props.item;

  const created = item.getCreatedDate().fromNow();
  const updated = item.getUpdatedDate().fromNow();

  return (
    <td className='col-date'>
      <span className='date-header'>Добавлено</span>
      <div className='date-value'>{created}</div>
      <span className='date-header'>Обновлено</span>
      <div className='date-value'>{updated}</div>

      <div className='vas-icon'>
        {
          item.isPremium()
              ? <span data-tip data-for='tip-premium' className='icon-premium'><span className='path1' /><span className='path2' /></span>
              : (item.isPromo() && <span data-tip data-for='tip-promo' className='icon-promo'><span className='path1' /><span className='path2' /></span>)
        }
      </div>
    </td>
  );
}

Date.propTypes = {
  item: PropTypes.object.isRequired
};

Date.defaultProps = {};

export default Date;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/Date.jsx